import * as React from 'react';
import PropTypes from 'prop-types';
import { DisplayInputsHeader } from '../Common/DisplayInputsHeader';

import * as Styles from './index.styles';

const { StyledWrapper, StyledSelect } = Styles;

export const DisplaySelect = ({ label, disabled, helperContent, ...otherProps }) => (
    <StyledWrapper>
        <DisplayInputsHeader text={label} disabled={disabled} helperContent={helperContent} />
        <StyledSelect disabled={disabled} {...otherProps} />
    </StyledWrapper>
);

DisplaySelect.propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.string,
    helperContent: PropTypes.node,
};

DisplaySelect.defaultProps = {
    label: '',
    disabled: false,
    helperContent: null,
};

DisplaySelect.Styles = Styles;

export default DisplaySelect;
